// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewPaymentQR-commonHeaderAdmin-zQUid {
	position: fixed !important;
}

.ViewPaymentQR-adminLayout-qg7rd {
	padding-top: 64px !important;
}

.ViewPaymentQR-box-tzpw5 h2 {
	font-size: 21px;
	font-weight: 600;
}

.ViewPaymentQR-exportLink-psrCy {
	margin-bottom: -29px;
}

.ViewPaymentQR-blockCenter-Kw9tv {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.ViewPaymentQR-panelHeader-iCuoq {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.ViewPaymentQR-currencyselect-iHCf_ {
	width: 100%;
	margin-right: 0px;
}

.ViewPaymentQR-panelHeader-iCuoq {
	overflow: hidden;
	position: relative;
}

.ViewPaymentQR-mar0-QeqW3 {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.ViewPaymentQR-blockCenter-Kw9tv {
		padding: 0px;
	}

	.ViewPaymentQR-panelHeader-iCuoq {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.ViewPaymentQR-sideAdminPageWrapper-nfgIH {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.ViewPaymentQR-panelHeader-iCuoq {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.ViewPaymentQR-table-VQRai {
	display: table;
}

.ViewPaymentQR-tableRow-Z8D57 {
	display: table-row;
}

.ViewPaymentQR-tableCell-rE8pE {
	display: table-cell;
	float: none;
}

.ViewPaymentQR-formGroup-PUQs4 {
	margin-bottom: 6px;
}

.ViewPaymentQR-select-lFIif {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.ViewPaymentQR-noMargin-QxMMk {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.ViewPaymentQR-exportLink-psrCy {
	padding-top: 10px;
	padding-right: 10px;
}

.ViewPaymentQR-labelTextNew-xmVeu {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.ViewPaymentQR-displayInline-m1Rr0 {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.ViewPaymentQR-btnUPdate-mtYrT {
	display: inline-block;
}

.ViewPaymentQR-btnModalDelete-VP0wJ {
	display: inline-block;
	margin-left: 15px;
}

.ViewPaymentQR-radioBtn-kW4d1 {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.ViewPaymentQR-backgroundImg-xBOHo {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.ViewPaymentQR-btnUPdate-mtYrT {
		display: block;
		margin-bottom: 12px;
	}

	.ViewPaymentQR-btnModalDelete-VP0wJ {
		display: block;
		margin-left: 0px;
	}

	.ViewPaymentQR-btnWidth-CxqYl {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.ViewPaymentQR-bannerImageBg-rPb50 {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.ViewPaymentQR-bannerDelete-cU4dK {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.ViewPaymentQR-modalRoot-TiC3z {
	padding: 32px;
}

.ViewPaymentQR-modalBorderBottom-i5uoW {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.ViewPaymentQR-logInModalBody-hDoup {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.ViewPaymentQR-exportSection-CCpIO {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.ViewPaymentQR-exportSectionGridSub-gh3iH {
	grid-template-columns: 50% 49% !important;
}

.ViewPaymentQR-exportText-ICQpc {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.ViewPaymentQR-exportLinkImg-LGeP6 {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.ViewPaymentQR-vtrMiddle-uwQtO {
	vertical-align: middle;
}

.ViewPaymentQR-exportImg-jtLAW {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.ViewPaymentQR-profileViewlabel-XWpJY {
	display: inline-block;
	width: 38%
}

.ViewPaymentQR-profileViewMainContent-PkePS {
	display: inline-block;
	width: 62%;
}

.ViewPaymentQR-profileViewMain-CMIG0 {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.ViewPaymentQR-profileViewInner-EO3R_ {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.ViewPaymentQR-profileImageSection-xKUce {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.ViewPaymentQR-lastviewInner-eFkLu {
	padding: 10px;
}

.ViewPaymentQR-whyHostHoriLine-FcP2S {
	margin: 30px 0;
}

.ViewPaymentQR-tableGrid-aIDoj {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.ViewPaymentQR-headingContent-xO05h {
	font-size: 18px;
	font-weight: 500;
}

.ViewPaymentQR-refundTextColor-qtAKX {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.ViewPaymentQR-dividerLine-JO_ny {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.ViewPaymentQR-smallContent-SBT8F {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.ViewPaymentQR-sideAdminPageWrapper-nfgIH {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.ViewPaymentQR-sideAdminPageWrapper-nfgIH {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.ViewPaymentQR-exportSection-CCpIO {
		grid-template-columns: 100%;
	}

	.ViewPaymentQR-exportSectionGridSub-gh3iH {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.ViewPaymentQR-profileViewlabel-XWpJY {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.ViewPaymentQR-profileViewMainContent-PkePS {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.ViewPaymentQR-ChangeToUpperCase-nS57b {
	text-transform: uppercase
}

.ViewPaymentQR-noBorder-XP6T0 {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.ViewPaymentQR-siteAdminHeading-TTUpS {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.ViewPaymentQR-siteAdminSubHeading-_p2PH {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.ViewPaymentQR-adminFormDivider-baVtf {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.ViewPaymentQR-space1-hbLb7 {
	margin-bottom: 6px !important;
}

.ViewPaymentQR-space2-pUsV0 {
	margin-bottom: 12px !important;
}

.ViewPaymentQR-space3-JHjQD {
	margin-bottom: 18px !important;
}

.ViewPaymentQR-space4-uQ9UZ {
	margin-bottom: 24px !important;
}

.ViewPaymentQR-space5-Fh1tK {
	margin-bottom: 30px !important;
}

.ViewPaymentQR-space6-C19IT {
	margin-bottom: 36px !important;
}

.ViewPaymentQR-space7-cnsmK {
	margin-bottom: 42px !important;
}

.ViewPaymentQR-spaceTop8-k_j28 {
	margin-bottom: 48px !important;
}

.ViewPaymentQR-spaceTop1-Pw_iS {
	margin-top: 6px !important;
}

.ViewPaymentQR-spaceTop2-tplqI {
	margin-top: 12px !important;
}

.ViewPaymentQR-spaceTop3-cgnev {
	margin-top: 18px !important;
}

.ViewPaymentQR-spaceTop4-dYeCo {
	margin-top: 24px !important;
}

.ViewPaymentQR-spaceTop5-eDyWy {
	margin-top: 30px !important;
}

.ViewPaymentQR-spaceTop6-pbSld {
	margin-top: 36px !important;
}

.ViewPaymentQR-spaceTop7-SwSYD {
	margin-top: 42px !important;
}

.ViewPaymentQR-spaceTop8-k_j28 {
	margin-top: 48px !important;
}

.ViewPaymentQR-noMargin-QxMMk {
	margin: 0px !important;
}

.ViewPaymentQR-padding1-RvKGA {
	padding-bottom: 6px !important;
}

.ViewPaymentQR-padding2-zwHTD {
	padding-bottom: 12px !important;
}

.ViewPaymentQR-padding3-EF034 {
	padding-bottom: 18px !important;
}

.ViewPaymentQR-padding4-NCjAc {
	padding-bottom: 24px !important;
}

.ViewPaymentQR-padding5-c0ZCL {
	padding-bottom: 30px !important;
}

.ViewPaymentQR-padding6-aSlKs {
	padding-bottom: 36px !important;
}

.ViewPaymentQR-padding7-ohlXz {
	padding-bottom: 42px !important;
}

.ViewPaymentQR-paddingTop1-vGR19 {
	padding-top: 6px !important;
}

.ViewPaymentQR-paddingTop2-kijEY {
	padding-top: 12px !important;
}

.ViewPaymentQR-paddingTop3-jNnpp {
	padding-top: 18px !important;
}

.ViewPaymentQR-paddingTop4-Cplh_ {
	padding-top: 24px !important;
}

.ViewPaymentQR-paddingTop5-Gaiwc {
	padding-top: 30px !important;
}

.ViewPaymentQR-paddingTop6-UubjW {
	padding-top: 36px !important;
}

.ViewPaymentQR-paddingTop7-eZgza {
	padding-top: 42px !important;
}

.ViewPaymentQR-noPadding-q1ZW0 {
	padding: 0px !important;
}

.ViewPaymentQR-textBold-hzqfg {
	font-weight: 500 !important;
}

.ViewPaymentQR-textBolder-JK39n {
	font-weight: 700 !important;
}

.ViewPaymentQR-textNormal-L3Kl4 {
	font-weight: normal !important;
}

.ViewPaymentQR-spaceBottom20-NpzX3 {
	margin-bottom: 20px;
}

.ViewPaymentQR-spaceBottom10-kGZ6H {
	margin-bottom: 10px;
}

.ViewPaymentQR-marginNone-lrmlb {
	margin: 0;
}

.ViewPaymentQR-spaceBottom15-pLhls {
	margin-bottom: 15px;
}

.ViewPaymentQR-marginTopNone-CH9zu {
	margin-top: 0;
}

.ViewPaymentQR-spaceTop11-duM_I {
	margin-top: 11px;
}

.ViewPaymentQR-spaceTop21-WkZ4y {
	margin-top: 21px;
}

.ViewPaymentQR-spaceTop20-iEYRp {
	margin-top: 20px;
}

.ViewPaymentQR-spaceTop10-gzYve {
	margin-top: 10px;
}

/*New Design Text Colors */

.ViewPaymentQR-textDarkBlue-iilRJ {
	color: rgb(20, 39, 94) !important;
}

.ViewPaymentQR-textLightBlue-Cu2ve {
	color: rgb(57, 87, 106) !important;
}

.ViewPaymentQR-textLightSandleGreen-cibCZ {
	color: rgb(76, 86, 41) !important;
}

.ViewPaymentQR-textLightBrown-DDa7h {
	color: rgb(115, 79, 33) !important;
}

.ViewPaymentQR-textMediumMaroon-bVSyY {
	color: rgb(87, 37, 51) !important;
}

.ViewPaymentQR-textBrown-CssE4 {
	color: rgb(160, 47, 24) !important;
}

.ViewPaymentQR-textMaroon-woh4P {
	color: rgb(155, 49, 67) !important;
}

.ViewPaymentQR-textDarkBrown-CELLZ {
	color: rgb(83, 18, 16) !important;
}

.ViewPaymentQR-textMediumBrown-gmGaL {
	color: rgb(142, 28, 10) !important;
}

.ViewPaymentQR-textSkyBlue-bjOnL {
	color: rgb(37, 117, 141) !important;
}

.ViewPaymentQR-textGray-P8eDy {
	color: rgb(77, 65, 51) !important;
}

.ViewPaymentQR-capitalize-SfiVc {
	text-transform: capitalize;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/helpers.css","webpack://./src/components/siteadmin/ViewPaymentQR/ViewPaymentQR.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;ACzNA;CACC,0BAA0B;AAC3B","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../admin-common.css';\n@import '../../helpers.css';\n\n.capitalize {\n\ttext-transform: capitalize;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `ViewPaymentQR-commonHeaderAdmin-zQUid`,
	"adminLayout": `ViewPaymentQR-adminLayout-qg7rd`,
	"box": `ViewPaymentQR-box-tzpw5`,
	"exportLink": `ViewPaymentQR-exportLink-psrCy`,
	"blockCenter": `ViewPaymentQR-blockCenter-Kw9tv`,
	"panelHeader": `ViewPaymentQR-panelHeader-iCuoq`,
	"currencyselect": `ViewPaymentQR-currencyselect-iHCf_`,
	"mar0": `ViewPaymentQR-mar0-QeqW3`,
	"sideAdminPageWrapper": `ViewPaymentQR-sideAdminPageWrapper-nfgIH`,
	"table": `ViewPaymentQR-table-VQRai`,
	"tableRow": `ViewPaymentQR-tableRow-Z8D57`,
	"tableCell": `ViewPaymentQR-tableCell-rE8pE`,
	"formGroup": `ViewPaymentQR-formGroup-PUQs4`,
	"select": `ViewPaymentQR-select-lFIif`,
	"noMargin": `ViewPaymentQR-noMargin-QxMMk`,
	"labelTextNew": `ViewPaymentQR-labelTextNew-xmVeu`,
	"displayInline": `ViewPaymentQR-displayInline-m1Rr0`,
	"btnUPdate": `ViewPaymentQR-btnUPdate-mtYrT`,
	"btnModalDelete": `ViewPaymentQR-btnModalDelete-VP0wJ`,
	"radioBtn": `ViewPaymentQR-radioBtn-kW4d1`,
	"backgroundImg": `ViewPaymentQR-backgroundImg-xBOHo`,
	"btnWidth": `ViewPaymentQR-btnWidth-CxqYl`,
	"bannerImageBg": `ViewPaymentQR-bannerImageBg-rPb50`,
	"bannerDelete": `ViewPaymentQR-bannerDelete-cU4dK`,
	"modalRoot": `ViewPaymentQR-modalRoot-TiC3z`,
	"modalBorderBottom": `ViewPaymentQR-modalBorderBottom-i5uoW`,
	"logInModalBody": `ViewPaymentQR-logInModalBody-hDoup`,
	"exportSection": `ViewPaymentQR-exportSection-CCpIO`,
	"exportSectionGridSub": `ViewPaymentQR-exportSectionGridSub-gh3iH`,
	"exportText": `ViewPaymentQR-exportText-ICQpc`,
	"exportLinkImg": `ViewPaymentQR-exportLinkImg-LGeP6`,
	"vtrMiddle": `ViewPaymentQR-vtrMiddle-uwQtO`,
	"exportImg": `ViewPaymentQR-exportImg-jtLAW`,
	"profileViewlabel": `ViewPaymentQR-profileViewlabel-XWpJY`,
	"profileViewMainContent": `ViewPaymentQR-profileViewMainContent-PkePS`,
	"profileViewMain": `ViewPaymentQR-profileViewMain-CMIG0`,
	"profileViewInner": `ViewPaymentQR-profileViewInner-EO3R_`,
	"profileImageSection": `ViewPaymentQR-profileImageSection-xKUce`,
	"lastviewInner": `ViewPaymentQR-lastviewInner-eFkLu`,
	"whyHostHoriLine": `ViewPaymentQR-whyHostHoriLine-FcP2S`,
	"tableGrid": `ViewPaymentQR-tableGrid-aIDoj`,
	"headingContent": `ViewPaymentQR-headingContent-xO05h`,
	"refundTextColor": `ViewPaymentQR-refundTextColor-qtAKX`,
	"dividerLine": `ViewPaymentQR-dividerLine-JO_ny`,
	"smallContent": `ViewPaymentQR-smallContent-SBT8F`,
	"ChangeToUpperCase": `ViewPaymentQR-ChangeToUpperCase-nS57b`,
	"noBorder": `ViewPaymentQR-noBorder-XP6T0`,
	"siteAdminHeading": `ViewPaymentQR-siteAdminHeading-TTUpS`,
	"siteAdminSubHeading": `ViewPaymentQR-siteAdminSubHeading-_p2PH`,
	"adminFormDivider": `ViewPaymentQR-adminFormDivider-baVtf`,
	"space1": `ViewPaymentQR-space1-hbLb7`,
	"space2": `ViewPaymentQR-space2-pUsV0`,
	"space3": `ViewPaymentQR-space3-JHjQD`,
	"space4": `ViewPaymentQR-space4-uQ9UZ`,
	"space5": `ViewPaymentQR-space5-Fh1tK`,
	"space6": `ViewPaymentQR-space6-C19IT`,
	"space7": `ViewPaymentQR-space7-cnsmK`,
	"spaceTop8": `ViewPaymentQR-spaceTop8-k_j28`,
	"spaceTop1": `ViewPaymentQR-spaceTop1-Pw_iS`,
	"spaceTop2": `ViewPaymentQR-spaceTop2-tplqI`,
	"spaceTop3": `ViewPaymentQR-spaceTop3-cgnev`,
	"spaceTop4": `ViewPaymentQR-spaceTop4-dYeCo`,
	"spaceTop5": `ViewPaymentQR-spaceTop5-eDyWy`,
	"spaceTop6": `ViewPaymentQR-spaceTop6-pbSld`,
	"spaceTop7": `ViewPaymentQR-spaceTop7-SwSYD`,
	"padding1": `ViewPaymentQR-padding1-RvKGA`,
	"padding2": `ViewPaymentQR-padding2-zwHTD`,
	"padding3": `ViewPaymentQR-padding3-EF034`,
	"padding4": `ViewPaymentQR-padding4-NCjAc`,
	"padding5": `ViewPaymentQR-padding5-c0ZCL`,
	"padding6": `ViewPaymentQR-padding6-aSlKs`,
	"padding7": `ViewPaymentQR-padding7-ohlXz`,
	"paddingTop1": `ViewPaymentQR-paddingTop1-vGR19`,
	"paddingTop2": `ViewPaymentQR-paddingTop2-kijEY`,
	"paddingTop3": `ViewPaymentQR-paddingTop3-jNnpp`,
	"paddingTop4": `ViewPaymentQR-paddingTop4-Cplh_`,
	"paddingTop5": `ViewPaymentQR-paddingTop5-Gaiwc`,
	"paddingTop6": `ViewPaymentQR-paddingTop6-UubjW`,
	"paddingTop7": `ViewPaymentQR-paddingTop7-eZgza`,
	"noPadding": `ViewPaymentQR-noPadding-q1ZW0`,
	"textBold": `ViewPaymentQR-textBold-hzqfg`,
	"textBolder": `ViewPaymentQR-textBolder-JK39n`,
	"textNormal": `ViewPaymentQR-textNormal-L3Kl4`,
	"spaceBottom20": `ViewPaymentQR-spaceBottom20-NpzX3`,
	"spaceBottom10": `ViewPaymentQR-spaceBottom10-kGZ6H`,
	"marginNone": `ViewPaymentQR-marginNone-lrmlb`,
	"spaceBottom15": `ViewPaymentQR-spaceBottom15-pLhls`,
	"marginTopNone": `ViewPaymentQR-marginTopNone-CH9zu`,
	"spaceTop11": `ViewPaymentQR-spaceTop11-duM_I`,
	"spaceTop21": `ViewPaymentQR-spaceTop21-WkZ4y`,
	"spaceTop20": `ViewPaymentQR-spaceTop20-iEYRp`,
	"spaceTop10": `ViewPaymentQR-spaceTop10-gzYve`,
	"textDarkBlue": `ViewPaymentQR-textDarkBlue-iilRJ`,
	"textLightBlue": `ViewPaymentQR-textLightBlue-Cu2ve`,
	"textLightSandleGreen": `ViewPaymentQR-textLightSandleGreen-cibCZ`,
	"textLightBrown": `ViewPaymentQR-textLightBrown-DDa7h`,
	"textMediumMaroon": `ViewPaymentQR-textMediumMaroon-bVSyY`,
	"textBrown": `ViewPaymentQR-textBrown-CssE4`,
	"textMaroon": `ViewPaymentQR-textMaroon-woh4P`,
	"textDarkBrown": `ViewPaymentQR-textDarkBrown-CELLZ`,
	"textMediumBrown": `ViewPaymentQR-textMediumBrown-gmGaL`,
	"textSkyBlue": `ViewPaymentQR-textSkyBlue-bjOnL`,
	"textGray": `ViewPaymentQR-textGray-P8eDy`,
	"capitalize": `ViewPaymentQR-capitalize-SfiVc`
};
module.exports = ___CSS_LOADER_EXPORT___;
